import { render, staticRenderFns } from "./StudyHabits.vue?vue&type=template&id=58e91c84&scoped=true"
import script from "./StudyHabits.vue?vue&type=script&lang=js"
export * from "./StudyHabits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e91c84",
  null
  
)

export default component.exports